import { FormConfig } from './formConfig.types';
import { makeTranslator } from 'sos-common/js/utils/translations';
import { allFormActions } from '../Redux/Actions/allActionTypes';
import { ADD_FILE } from '../Redux/Actions';
import { ResourceItem } from 'SoS.Optimizely.Common/ClientSource/js/commonTypes/resourceItem';
import { StepFieldsMap } from 'SoS.Optimizely.Common/ClientSource/js/commonTypes/validation.types';
export abstract class DefaultFormConfig implements FormConfig {
  public translate: ReturnType<typeof makeTranslator>;
  constructor(private translations: ResourceItem[], public basePath: string, public stepFieldsMap: StepFieldsMap) {
    this.translate = makeTranslator(this.translations);
  }

  public errorMessageResolver(action: allFormActions) {
    switch (action.type) {
      case ADD_FILE:
        return this.translate('|global|generalFileUploadError');
      default:
        return '';
    }
  }
}
